import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";
// import {
//   getToken,
//   setToken,
//   removeToken,
//   getStoreId,
//   setStoreId,
//   removeStoreId,
//   setUserInfo,
//   getUserInfo,
//   removeUserInfo
// } from "@/utils/cookies";
// import store from "@/store";

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () => import("@/views/login/index.vue"),
      meta: { title: "硕学汇志愿规划", hidden: true, notNeedAuth: true }
    },
    {
      path: "/404",
      component: () => import("@/views/404.vue"),
      meta: { title: "硕学汇志愿规划", hidden: true, notNeedAuth: true }
    },
    {
      path: "/",
      component: Layout,
      redirect: "/employee",
      children: [

        {
          path: "employee",
          component: () => import("@/views/employee/index.vue"),
          meta: {
            title: "员工管理",
            icon: "icon-employee"
          }
        },

        {
          path: "/employee/add",
          component: () => import("@/views/employee/addEmployee.vue"),
          meta: {
            title: "添加/修改员工",
            hidden: true
          }
        },

        {
          path: "consultant",
          component: () => import("@/views/consultant/index.vue"),
          meta: {
            title: "咨询师管理",
            icon: "icon-zixunshi"
          }
        },
        {
          path: "/consultant/add",
          component: () => import("@/views/consultant/addConsultant.vue"),
          meta: {
            title: "添加/修改咨询师",
            hidden: true
          }
        },
        {
          path: "logs",
          component: () => import("@/views/operatelog/index.vue"),
          meta: {
            title: "日志查询",
            icon: "icon-order"
          }
        },
        {
          path: "receipts",
          component: () => import("@/views/receipts/index.vue"),
          meta: {
            title: "交易信息",
            icon: "icon-fapiaoshouju"
          }
        },
        {
          path: "receipts/consultantReceipt",
          component: () => import("@/views/receipts/consultantReceipt.vue"),
          meta: {
            title: "咨询师交易",
            // icon: "icon-fapiaoshouju"
            hidden: true
          }
        },
        {
          path: "receipts/updateReceipt",
          component: () => import("@/views/receipts/updateReceipt.vue"),
          meta: {
            title: "修改收据信息",
            // icon: "icon-fapiaoshouju"
            hidden: true
          }
        },
        {
          path: "clienteles",
          component: () => import("@/views/clienteles/index.vue"),
          meta: {
            title: "客单管理",
            icon: "icon-clientele"
          }
        },
        {
          path: "/clienteles/add",
          component: () => import("@/views/clienteles/addClientele.vue"),
          meta: {
            title: "客单操作",
            hidden: true
          }
        },

      ]
    },
    {
      path: "*",
      redirect: "/404",
      meta: { hidden: true }
    }
  ]
});

export default router;
